/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import moment from 'jalali-moment'

import Menu from '../../../../components/CustomerClub/Menu'

import { get, put } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { useParams } from 'react-router'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import Switch from "react-switch"

import commentIcon from '../../../../assets/svg/Comment.svg'
import sadEmoji from '../../../../assets/svg/SaadEmoji.svg'
import unhappyEmoji from '../../../../assets/svg/UnhappyEmoji.svg'
import happyEmoji from '../../../../assets/svg/HappyEmoji.svg'
import enjoyEmoji from '../../../../assets/svg/EnjoyEmoji.svg'

import { ToRial } from '../../../../services/toRial'

export default function index() {
  document.title = 'جزئیات دیدگاه'

  const { id } = useParams()

  const navigate = useNavigate()

  const [order, setOrder] = useState([])
  const [basket, setBasket] = useState([])
  const [user, setUser] = useState([])
  const [branch, setBranch] = useState([])
  const [orderWay, setOrderWay] = useState([])
  const [orderStatus, setOrderStatus] = useState('')
  const [commentScore, setCommentScore] = useState('')

  const [quality, setQuality] = useState('')
  const [peyk, setPeyk] = useState('')
  const [exprience, setExprience] = useState('')
  const [value, setValue] = useState('')
  const [packaging, setPackaging] = useState('')
  const [message, setMessage] = useState('')
  const [commentStatus, setCommentStatus] = useState('')
  const [commentId, setCommentId] = useState('')

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/cccomments/${id}?token=${token}`)
      .then(response => {
        setCommentId(response.data.data[0]._id)
        setOrder(response.data.data[0].order[0])
        setBasket(response.data.data[0].order[0].basket)
        setOrderWay(response.data.data[0].order[0].basket)
        setCommentScore(response.data.data[0].score)
        setQuality(response.data.data[0].quality)
        setPeyk(response.data.data[0].peyk)
        setExprience(response.data.data[0].exprience)
        setValue(response.data.data[0].value)
        setPackaging(response.data.data[0].packaging)
        setMessage(response.data.data[0].message)
        setCommentStatus(response.data.data[0].status)

        switch(response.data.data[0].order[0].orderStatus) {
          case 'new':
            setOrderStatus('سفارش جدید')
            break
          case 'doing':
            setOrderStatus('سفارش در حال انجام')
            break
          case 'ready':
            setOrderStatus('سفارش آماده تحویل')
            break
          case 'done':
            setOrderStatus('تحویل داده شده')
            break
          case 'cancel':
            setOrderStatus('سفارش کنسل شده')
            break
          default :
            setOrderStatus('')
            break
        }
      })
      .catch(error => {
        if(error) {
          notify('error', 'خطا در ارسال اطلاعات')
        }
      })

    get(`/api/admin/order/${id}?token=${token}`)
      .then(response => {
        setUser(response.data.data.user)
        setBranch(response.data.data.branch)
      })
      .catch(error => {
        if(error) {
          notify('error', 'خطا در ارسال اطلاعات')
        }      
      })
  }, [id, token])

  const statusHandler = () => {
    let data = { status: true }
    setCommentStatus(!commentStatus)
    if (commentStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/cccomments/status/${commentId}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/cc/comments')
        }, 2000)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'comments'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
        <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={commentIcon} alt='foodIcon' />
              </div>
              <div className='text'>
                دیدگاه : <progress id="file" value={commentScore} max="20"></progress>
              </div>
            </div>

            <div className="left">
              <Switch onChange={statusHandler} 
                checked={commentStatus ? commentStatus : false} 
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={30}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={20}
                width={48}
                className="react-switch"
                id="material-switch"
                />
            </div>
          </div>
          <div className='form'>
            <div className='title'>
              سفارش شماره : {order.orderNumber} - وضعیت سفارش : {orderStatus}
            </div>
            <div className='lineTitleFood'>
              <hr />
                اطلاعات سفارش
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>تاریخ خرید :</label>
                <div className='text'>{moment(order.createdAt).locale('fa').format('YYYY/MM/DD HH:mm')}</div>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>پرداخت :</label>
                <div className='text'>{order.payStatus ? (
                  <div className="success">پرداخت شده  - آیدی پرداخت : {order.refId}</div>
                ) : (
                  <div className="failed">پرداخت نشده  - آیدی پرداخت : -</div>
                )}</div>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>جمع سبد خرید :</label>
                <div className='text'>{ToRial(String(order.productsTotal))} تومان</div>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>هزینه ارسال :</label>
                <div className='text'>{ToRial(String(order.shippingCost))} تومان</div>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>هزینه کل :</label>
                <div className='text'>{ToRial(String(order.total))} تومان</div>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>کد تخفیف :</label>
                <div className='text'>{ToRial(String(order.totalDiscount))} تومان - '{order.discount}'</div>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>سبد خرید :</label>
                <ul className='list'>
                  {basket ? basket.map(item => (
                    <li key={item._id}>{item.name} - تعداد : ({item.count}) - قیمت هر واحد : ({ToRial(String(item.price))}) - قیمت کل : ({ToRial(String(item.allPrice))})</li>
                  )) : ''}
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>مشخصات خریدار :</label>
                <ul className='list'>
                  {user ? user.map(item => (
                    <li key={item._id}>{item.name} - 0{item.phoneNumber}</li>
                  )) : ''}
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>خرید از شعبه :</label>
                <ul className='list'>
                  {branch ? branch.map(item => (
                    <li key={item._id}>{item.name} - {item.description}</li>
                  )) : ''}
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>نحوه ارسال :</label>
                <ul className='list'>
                  <li>{orderWay.type === 'peyk' ? 'پیک' : 'حضوری'} - {orderWay.type === 'peyk' ? 'آدرس : ' + orderWay.orderDetail.addressSelect + ' - پلاک : ' + orderWay.orderDetail.plak : orderWay.orderDetail}</li>
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>زمان تحویل:</label>
                <ul className='list'>
                  <li>{order.timeDeliver}</li>
                </ul>
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
                سوالات
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <div className='text'>کیفیت غذا :</div>
                <div className='text'>برخورد پیک :</div>
                <div className='text'>تجربه سفارش آنلاین :</div>
                <div className='text'>حجم غذا :</div>
                <div className='text'>بسته بندی :</div>
              </div>
              <div className='column'>
                <div className='text' style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                  <img src={enjoyEmoji} style={quality === 4 ? { opacity: '1' } : { opacity: '0.5' }} alt="enjoyEmoji" />
                  <img src={happyEmoji} style={quality === 3 ? { opacity: '1' } : { opacity: '0.5' }} alt="happyEmoji" />
                  <img src={unhappyEmoji} style={quality === 2 ? { opacity: '1' } : { opacity: '0.5' }} alt="unhappyEmoji" />
                  <img src={sadEmoji} style={quality === 1 ? { opacity: '1' } : { opacity: '0.5' }} alt="sadEmoji" />
                </div>
                <div className='text' style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                  <img src={enjoyEmoji} style={peyk === 4 ? { opacity: '1' } : { opacity: '0.5' }} alt="enjoyEmoji" />
                  <img src={happyEmoji} style={peyk === 3 ? { opacity: '1' } : { opacity: '0.5' }} alt="happyEmoji" />
                  <img src={unhappyEmoji} style={peyk === 2 ? { opacity: '1' } : { opacity: '0.5' }} alt="unhappyEmoji" />
                  <img src={sadEmoji} style={peyk === 1 ? { opacity: '1' } : { opacity: '0.5' }} alt="sadEmoji" />
                </div>
                <div className='text' style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                  <img src={enjoyEmoji} style={exprience === 4 ? { opacity: '1' } : { opacity: '0.5' }} alt="enjoyEmoji" />
                  <img src={happyEmoji} style={exprience === 3 ? { opacity: '1' } : { opacity: '0.5' }} alt="happyEmoji" />
                  <img src={unhappyEmoji} style={exprience === 2 ? { opacity: '1' } : { opacity: '0.5' }} alt="unhappyEmoji" />
                  <img src={sadEmoji} style={exprience === 1 ? { opacity: '1' } : { opacity: '0.5' }} alt="sadEmoji" />
                </div>
                <div className='text' style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                  <img src={enjoyEmoji} style={value === 4 ? { opacity: '1' } : { opacity: '0.5' }} alt="enjoyEmoji" />
                  <img src={happyEmoji} style={value === 3 ? { opacity: '1' } : { opacity: '0.5' }} alt="happyEmoji" />
                  <img src={unhappyEmoji} style={value === 2 ? { opacity: '1' } : { opacity: '0.5' }} alt="unhappyEmoji" />
                  <img src={sadEmoji} style={value === 1 ? { opacity: '1' } : { opacity: '0.5' }} alt="sadEmoji" />
                </div>
                <div className='text' style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                  <img src={enjoyEmoji} style={packaging === 4 ? { opacity: '1' } : { opacity: '0.5' }} alt="enjoyEmoji" />
                  <img src={happyEmoji} style={packaging === 3 ? { opacity: '1' } : { opacity: '0.5' }} alt="happyEmoji" />
                  <img src={unhappyEmoji} style={packaging === 2 ? { opacity: '1' } : { opacity: '0.5' }} alt="unhappyEmoji" />
                  <img src={sadEmoji} style={packaging === 1 ? { opacity: '1' } : { opacity: '0.5' }} alt="sadEmoji" />
                </div>
              </div>
            </div>
            <div>پیغام : {message}</div>
          </div>
          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}